export const stakingContract = "0x9dddF8B7680C3E1A41c44308388e5FB1330963c7";
export const tokenContract = "0x224881Ab70F91A1aaD0C71cb985cA60D4767Fec3";
export const stakingLpContract = "0x34211818bCa3343B86699ddf3106E7a3af8BbCC1";
export const lpTokenContract = "0x2E92263db05b63848330ECD6c54A1FBD77E13eE5";
